module.exports = __webpack_public_path__ + "static/media/Key_Viewfinder.3bda34ce.jpg";